






















































import { RimRepairLayoutComponent } from "@/components/common";
import { Component, Vue, Prop } from "vue-property-decorator";
import { GetInvoice, GetCustomer, GetWorOrder } from "@/api";
import { IInvoice, ICustomer } from "@/interfaces";
import CustomerCard from "./customer-card.vue";
import PaymentMethodsComponent from "./payment-methods.vue";
import VehiclesTableComponent from "./vehicles-table.vue";
import { makeInvoice } from "@/utils";
@Component({
  components: {
    RimRepairLayoutComponent,
    CustomerCard,
    PaymentMethodsComponent,
    VehiclesTableComponent,
  },
})
export default class InvoiceDetailsComponent extends Vue {
  public invoice: IInvoice | null = null;
  public customer: ICustomer | null = null;
  public loading = true;

  mounted() {
    this.getData();
  }

  async getData() {
    try {
      this.loading = true;
      const resp = await GetInvoice(this.$route.params.id);
      this.invoice = makeInvoice({
        Invoice: resp.Invoice,
      });
      const customerResp = await GetCustomer(+this.invoice.Invoice.CustomerID!);
      this.customer = customerResp.Customer;
      this.loading = false;
    } catch (err) {
      //
    }
  }

  public GetReturnPath(): string {
    var isController = this.$route.meta.IsController;

    var rval: string = isController ? "/invoices-controller" : "/invoices";

    return rval;
	}

  public HasFlag(id: number): boolean {
    if (!this.customer) return false;
    var iof = this.customer.CustType.CustTypeFlags.indexOf(id);
    var hasIt: boolean = iof > -1;
    return hasIt;
  }	


}
